/**
 * El historial guarda uno o varios PDF en una sola columna `fileName`.
 * Modo combinado: un nombre. Modo un PDF por dashboard: los une con ", "
 * (ver reportGenerator.js). Cada archivo en disco es independiente; hay que
 * partir esa lista para descargarlos.
 */

export function parseReportPdfFileNames(raw) {
  const parts = Array.isArray(raw) ? raw : [raw];
  const names = [];
  parts.forEach((item) => {
    String(item || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((name) => names.push(name));
  });
  const seen = new Set();
  return names.filter((name) => {
    if (name.includes('..') || /[\\/]/.test(name)) return false;
    if (seen.has(name)) return false;
    seen.add(name);
    return true;
  });
}

export function joinReportPdfFileNames(names) {
  return parseReportPdfFileNames(names).join(', ');
}
